// Auto-generated by @vm0/firewalls-generator.
// Regenerate: cd turbo && pnpm -F @vm0/firewalls-generator generate
//
// DO NOT EDIT THIS FILE MANUALLY.
// The platform build serves these dynamic imports from /firewall-metadata/permission-details/v1/.
// Bump that URL version before shipping an incompatible metadata module shape or import contract change.
import type { FirewallPermissionDetailMetadata } from "./types";

const FIREWALL_PERMISSION_METADATA_LOADERS: Readonly<
  Record<string, () => Promise<FirewallPermissionDetailMetadata>>
> = Object.assign(Object.create(null), {
  ["adzuna"]: async () => {
    return (await import("./permission-details/adzuna.generated" as string))["firewallPermissionMetadata"];
  },
  ["agentmail"]: async () => {
    return (await import("./permission-details/agentmail.generated" as string))["firewallPermissionMetadata"];
  },
  ["agora"]: async () => {
    return (await import("./permission-details/agora.generated" as string))["firewallPermissionMetadata"];
  },
  ["ahrefs"]: async () => {
    return (await import("./permission-details/ahrefs.generated" as string))["firewallPermissionMetadata"];
  },
  ["airtable"]: async () => {
    return (await import("./permission-details/airtable.generated" as string))["firewallPermissionMetadata"];
  },
  ["alchemy"]: async () => {
    return (await import("./permission-details/alchemy.generated" as string))["firewallPermissionMetadata"];
  },
  ["altium-365"]: async () => {
    return (await import("./permission-details/altium-365.generated" as string))["firewallPermissionMetadata"];
  },
  ["amadeus"]: async () => {
    return (await import("./permission-details/amadeus.generated" as string))["firewallPermissionMetadata"];
  },
  ["amplitude"]: async () => {
    return (await import("./permission-details/amplitude.generated" as string))["firewallPermissionMetadata"];
  },
  ["anthropic-managed-agents"]: async () => {
    return (await import("./permission-details/anthropic-managed-agents.generated" as string))["firewallPermissionMetadata"];
  },
  ["apify"]: async () => {
    return (await import("./permission-details/apify.generated" as string))["firewallPermissionMetadata"];
  },
  ["apollo"]: async () => {
    return (await import("./permission-details/apollo.generated" as string))["firewallPermissionMetadata"];
  },
  ["asana"]: async () => {
    return (await import("./permission-details/asana.generated" as string))["firewallPermissionMetadata"];
  },
  ["ashby"]: async () => {
    return (await import("./permission-details/ashby.generated" as string))["firewallPermissionMetadata"];
  },
  ["atlascloud"]: async () => {
    return (await import("./permission-details/atlascloud.generated" as string))["firewallPermissionMetadata"];
  },
  ["atlassian"]: async () => {
    return (await import("./permission-details/atlassian.generated" as string))["firewallPermissionMetadata"];
  },
  ["attio"]: async () => {
    return (await import("./permission-details/attio.generated" as string))["firewallPermissionMetadata"];
  },
  ["aviationstack"]: async () => {
    return (await import("./permission-details/aviationstack.generated" as string))["firewallPermissionMetadata"];
  },
  ["aws"]: async () => {
    return (await import("./permission-details/aws.generated" as string))["firewallPermissionMetadata"];
  },
  ["axiom"]: async () => {
    return (await import("./permission-details/axiom.generated" as string))["firewallPermissionMetadata"];
  },
  ["base44"]: async () => {
    return (await import("./permission-details/base44.generated" as string))["firewallPermissionMetadata"];
  },
  ["bentoml"]: async () => {
    return (await import("./permission-details/bentoml.generated" as string))["firewallPermissionMetadata"];
  },
  ["bfl"]: async () => {
    return (await import("./permission-details/bfl.generated" as string))["firewallPermissionMetadata"];
  },
  ["bill"]: async () => {
    return (await import("./permission-details/bill.generated" as string))["firewallPermissionMetadata"];
  },
  ["bitrefill"]: async () => {
    return (await import("./permission-details/bitrefill.generated" as string))["firewallPermissionMetadata"];
  },
  ["bitrix"]: async () => {
    return (await import("./permission-details/bitrix.generated" as string))["firewallPermissionMetadata"];
  },
  ["bland"]: async () => {
    return (await import("./permission-details/bland.generated" as string))["firewallPermissionMetadata"];
  },
  ["box"]: async () => {
    return (await import("./permission-details/box.generated" as string))["firewallPermissionMetadata"];
  },
  ["brave-search"]: async () => {
    return (await import("./permission-details/brave-search.generated" as string))["firewallPermissionMetadata"];
  },
  ["brevo"]: async () => {
    return (await import("./permission-details/brevo.generated" as string))["firewallPermissionMetadata"];
  },
  ["brex"]: async () => {
    return (await import("./permission-details/brex.generated" as string))["firewallPermissionMetadata"];
  },
  ["bright-data"]: async () => {
    return (await import("./permission-details/bright-data.generated" as string))["firewallPermissionMetadata"];
  },
  ["browser-use"]: async () => {
    return (await import("./permission-details/browser-use.generated" as string))["firewallPermissionMetadata"];
  },
  ["browserbase"]: async () => {
    return (await import("./permission-details/browserbase.generated" as string))["firewallPermissionMetadata"];
  },
  ["browserless"]: async () => {
    return (await import("./permission-details/browserless.generated" as string))["firewallPermissionMetadata"];
  },
  ["browserstack"]: async () => {
    return (await import("./permission-details/browserstack.generated" as string))["firewallPermissionMetadata"];
  },
  ["bubblemaps"]: async () => {
    return (await import("./permission-details/bubblemaps.generated" as string))["firewallPermissionMetadata"];
  },
  ["buffer"]: async () => {
    return (await import("./permission-details/buffer.generated" as string))["firewallPermissionMetadata"];
  },
  ["builtwith"]: async () => {
    return (await import("./permission-details/builtwith.generated" as string))["firewallPermissionMetadata"];
  },
  ["cal-com"]: async () => {
    return (await import("./permission-details/cal-com.generated" as string))["firewallPermissionMetadata"];
  },
  ["calendly"]: async () => {
    return (await import("./permission-details/calendly.generated" as string))["firewallPermissionMetadata"];
  },
  ["canva"]: async () => {
    return (await import("./permission-details/canva.generated" as string))["firewallPermissionMetadata"];
  },
  ["chatwoot"]: async () => {
    return (await import("./permission-details/chatwoot.generated" as string))["firewallPermissionMetadata"];
  },
  ["checkr"]: async () => {
    return (await import("./permission-details/checkr.generated" as string))["firewallPermissionMetadata"];
  },
  ["clado"]: async () => {
    return (await import("./permission-details/clado.generated" as string))["firewallPermissionMetadata"];
  },
  ["clearbit"]: async () => {
    return (await import("./permission-details/clearbit.generated" as string))["firewallPermissionMetadata"];
  },
  ["clerk"]: async () => {
    return (await import("./permission-details/clerk.generated" as string))["firewallPermissionMetadata"];
  },
  ["clickup"]: async () => {
    return (await import("./permission-details/clickup.generated" as string))["firewallPermissionMetadata"];
  },
  ["close"]: async () => {
    return (await import("./permission-details/close.generated" as string))["firewallPermissionMetadata"];
  },
  ["cloudflare"]: async () => {
    return (await import("./permission-details/cloudflare.generated" as string))["firewallPermissionMetadata"];
  },
  ["coda"]: async () => {
    return (await import("./permission-details/coda.generated" as string))["firewallPermissionMetadata"];
  },
  ["coingecko"]: async () => {
    return (await import("./permission-details/coingecko.generated" as string))["firewallPermissionMetadata"];
  },
  ["copper"]: async () => {
    return (await import("./permission-details/copper.generated" as string))["firewallPermissionMetadata"];
  },
  ["coresignal"]: async () => {
    return (await import("./permission-details/coresignal.generated" as string))["firewallPermissionMetadata"];
  },
  ["cronlytic"]: async () => {
    return (await import("./permission-details/cronlytic.generated" as string))["firewallPermissionMetadata"];
  },
  ["crustdata"]: async () => {
    return (await import("./permission-details/crustdata.generated" as string))["firewallPermissionMetadata"];
  },
  ["cursor"]: async () => {
    return (await import("./permission-details/cursor.generated" as string))["firewallPermissionMetadata"];
  },
  ["customer-io"]: async () => {
    return (await import("./permission-details/customer-io.generated" as string))["firewallPermissionMetadata"];
  },
  ["datadog"]: async () => {
    return (await import("./permission-details/datadog.generated" as string))["firewallPermissionMetadata"];
  },
  ["daytona"]: async () => {
    return (await import("./permission-details/daytona.generated" as string))["firewallPermissionMetadata"];
  },
  ["db9"]: async () => {
    return (await import("./permission-details/db9.generated" as string))["firewallPermissionMetadata"];
  },
  ["deel"]: async () => {
    return (await import("./permission-details/deel.generated" as string))["firewallPermissionMetadata"];
  },
  ["deepseek"]: async () => {
    return (await import("./permission-details/deepseek.generated" as string))["firewallPermissionMetadata"];
  },
  ["defillama"]: async () => {
    return (await import("./permission-details/defillama.generated" as string))["firewallPermissionMetadata"];
  },
  ["devto"]: async () => {
    return (await import("./permission-details/devto.generated" as string))["firewallPermissionMetadata"];
  },
  ["diffbot"]: async () => {
    return (await import("./permission-details/diffbot.generated" as string))["firewallPermissionMetadata"];
  },
  ["dify"]: async () => {
    return (await import("./permission-details/dify.generated" as string))["firewallPermissionMetadata"];
  },
  ["discord"]: async () => {
    return (await import("./permission-details/discord.generated" as string))["firewallPermissionMetadata"];
  },
  ["discord-webhook"]: async () => {
    return (await import("./permission-details/discord-webhook.generated" as string))["firewallPermissionMetadata"];
  },
  ["docusign"]: async () => {
    return (await import("./permission-details/docusign.generated" as string))["firewallPermissionMetadata"];
  },
  ["doppler"]: async () => {
    return (await import("./permission-details/doppler.generated" as string))["firewallPermissionMetadata"];
  },
  ["doubao"]: async () => {
    return (await import("./permission-details/doubao.generated" as string))["firewallPermissionMetadata"];
  },
  ["drive9"]: async () => {
    return (await import("./permission-details/drive9.generated" as string))["firewallPermissionMetadata"];
  },
  ["dropbox"]: async () => {
    return (await import("./permission-details/dropbox.generated" as string))["firewallPermissionMetadata"];
  },
  ["dropbox-sign"]: async () => {
    return (await import("./permission-details/dropbox-sign.generated" as string))["firewallPermissionMetadata"];
  },
  ["duffel"]: async () => {
    return (await import("./permission-details/duffel.generated" as string))["firewallPermissionMetadata"];
  },
  ["e2b"]: async () => {
    return (await import("./permission-details/e2b.generated" as string))["firewallPermissionMetadata"];
  },
  ["elevenlabs"]: async () => {
    return (await import("./permission-details/elevenlabs.generated" as string))["firewallPermissionMetadata"];
  },
  ["etherscan"]: async () => {
    return (await import("./permission-details/etherscan.generated" as string))["firewallPermissionMetadata"];
  },
  ["etsy"]: async () => {
    return (await import("./permission-details/etsy.generated" as string))["firewallPermissionMetadata"];
  },
  ["exa"]: async () => {
    return (await import("./permission-details/exa.generated" as string))["firewallPermissionMetadata"];
  },
  ["expensify"]: async () => {
    return (await import("./permission-details/expensify.generated" as string))["firewallPermissionMetadata"];
  },
  ["explorium"]: async () => {
    return (await import("./permission-details/explorium.generated" as string))["firewallPermissionMetadata"];
  },
  ["faire"]: async () => {
    return (await import("./permission-details/faire.generated" as string))["firewallPermissionMetadata"];
  },
  ["fal"]: async () => {
    return (await import("./permission-details/fal.generated" as string))["firewallPermissionMetadata"];
  },
  ["figma"]: async () => {
    return (await import("./permission-details/figma.generated" as string))["firewallPermissionMetadata"];
  },
  ["firecrawl"]: async () => {
    return (await import("./permission-details/firecrawl.generated" as string))["firewallPermissionMetadata"];
  },
  ["fireflies"]: async () => {
    return (await import("./permission-details/fireflies.generated" as string))["firewallPermissionMetadata"];
  },
  ["flightaware"]: async () => {
    return (await import("./permission-details/flightaware.generated" as string))["firewallPermissionMetadata"];
  },
  ["freshdesk"]: async () => {
    return (await import("./permission-details/freshdesk.generated" as string))["firewallPermissionMetadata"];
  },
  ["gamma"]: async () => {
    return (await import("./permission-details/gamma.generated" as string))["firewallPermissionMetadata"];
  },
  ["garmin-connect"]: async () => {
    return (await import("./permission-details/garmin-connect.generated" as string))["firewallPermissionMetadata"];
  },
  ["gemini"]: async () => {
    return (await import("./permission-details/gemini.generated" as string))["firewallPermissionMetadata"];
  },
  ["github"]: async () => {
    return (await import("./permission-details/github.generated" as string))["firewallPermissionMetadata"];
  },
  ["gitlab"]: async () => {
    return (await import("./permission-details/gitlab.generated" as string))["firewallPermissionMetadata"];
  },
  ["gmail"]: async () => {
    return (await import("./permission-details/gmail.generated" as string))["firewallPermissionMetadata"];
  },
  ["gong"]: async () => {
    return (await import("./permission-details/gong.generated" as string))["firewallPermissionMetadata"];
  },
  ["google-ads"]: async () => {
    return (await import("./permission-details/google-ads.generated" as string))["firewallPermissionMetadata"];
  },
  ["google-analytics"]: async () => {
    return (await import("./permission-details/google-analytics.generated" as string))["firewallPermissionMetadata"];
  },
  ["google-calendar"]: async () => {
    return (await import("./permission-details/google-calendar.generated" as string))["firewallPermissionMetadata"];
  },
  ["google-cloud"]: async () => {
    return (await import("./permission-details/google-cloud.generated" as string))["firewallPermissionMetadata"];
  },
  ["google-contacts"]: async () => {
    return (await import("./permission-details/google-contacts.generated" as string))["firewallPermissionMetadata"];
  },
  ["google-docs"]: async () => {
    return (await import("./permission-details/google-docs.generated" as string))["firewallPermissionMetadata"];
  },
  ["google-drive"]: async () => {
    return (await import("./permission-details/google-drive.generated" as string))["firewallPermissionMetadata"];
  },
  ["google-forms"]: async () => {
    return (await import("./permission-details/google-forms.generated" as string))["firewallPermissionMetadata"];
  },
  ["google-maps"]: async () => {
    return (await import("./permission-details/google-maps.generated" as string))["firewallPermissionMetadata"];
  },
  ["google-meet"]: async () => {
    return (await import("./permission-details/google-meet.generated" as string))["firewallPermissionMetadata"];
  },
  ["google-search-console"]: async () => {
    return (await import("./permission-details/google-search-console.generated" as string))["firewallPermissionMetadata"];
  },
  ["google-sheets"]: async () => {
    return (await import("./permission-details/google-sheets.generated" as string))["firewallPermissionMetadata"];
  },
  ["granola"]: async () => {
    return (await import("./permission-details/granola.generated" as string))["firewallPermissionMetadata"];
  },
  ["greenhouse"]: async () => {
    return (await import("./permission-details/greenhouse.generated" as string))["firewallPermissionMetadata"];
  },
  ["groq"]: async () => {
    return (await import("./permission-details/groq.generated" as string))["firewallPermissionMetadata"];
  },
  ["gumroad"]: async () => {
    return (await import("./permission-details/gumroad.generated" as string))["firewallPermissionMetadata"];
  },
  ["helicone"]: async () => {
    return (await import("./permission-details/helicone.generated" as string))["firewallPermissionMetadata"];
  },
  ["heygen"]: async () => {
    return (await import("./permission-details/heygen.generated" as string))["firewallPermissionMetadata"];
  },
  ["hitem3d"]: async () => {
    return (await import("./permission-details/hitem3d.generated" as string))["firewallPermissionMetadata"];
  },
  ["honcho"]: async () => {
    return (await import("./permission-details/honcho.generated" as string))["firewallPermissionMetadata"];
  },
  ["htmlcsstoimage"]: async () => {
    return (await import("./permission-details/htmlcsstoimage.generated" as string))["firewallPermissionMetadata"];
  },
  ["hubspot"]: async () => {
    return (await import("./permission-details/hubspot.generated" as string))["firewallPermissionMetadata"];
  },
  ["hugging-face"]: async () => {
    return (await import("./permission-details/hugging-face.generated" as string))["firewallPermissionMetadata"];
  },
  ["hume"]: async () => {
    return (await import("./permission-details/hume.generated" as string))["firewallPermissionMetadata"];
  },
  ["hunter"]: async () => {
    return (await import("./permission-details/hunter.generated" as string))["firewallPermissionMetadata"];
  },
  ["imgur"]: async () => {
    return (await import("./permission-details/imgur.generated" as string))["firewallPermissionMetadata"];
  },
  ["infisical"]: async () => {
    return (await import("./permission-details/infisical.generated" as string))["firewallPermissionMetadata"];
  },
  ["insforge"]: async () => {
    return (await import("./permission-details/insforge.generated" as string))["firewallPermissionMetadata"];
  },
  ["instagram"]: async () => {
    return (await import("./permission-details/instagram.generated" as string))["firewallPermissionMetadata"];
  },
  ["instantly"]: async () => {
    return (await import("./permission-details/instantly.generated" as string))["firewallPermissionMetadata"];
  },
  ["intercom"]: async () => {
    return (await import("./permission-details/intercom.generated" as string))["firewallPermissionMetadata"];
  },
  ["intervals-icu"]: async () => {
    return (await import("./permission-details/intervals-icu.generated" as string))["firewallPermissionMetadata"];
  },
  ["ironclad"]: async () => {
    return (await import("./permission-details/ironclad.generated" as string))["firewallPermissionMetadata"];
  },
  ["jam"]: async () => {
    return (await import("./permission-details/jam.generated" as string))["firewallPermissionMetadata"];
  },
  ["jira"]: async () => {
    return (await import("./permission-details/jira.generated" as string))["firewallPermissionMetadata"];
  },
  ["jotform"]: async () => {
    return (await import("./permission-details/jotform.generated" as string))["firewallPermissionMetadata"];
  },
  ["klaviyo"]: async () => {
    return (await import("./permission-details/klaviyo.generated" as string))["firewallPermissionMetadata"];
  },
  ["kommo"]: async () => {
    return (await import("./permission-details/kommo.generated" as string))["firewallPermissionMetadata"];
  },
  ["langfuse"]: async () => {
    return (await import("./permission-details/langfuse.generated" as string))["firewallPermissionMetadata"];
  },
  ["langsmith"]: async () => {
    return (await import("./permission-details/langsmith.generated" as string))["firewallPermissionMetadata"];
  },
  ["lark"]: async () => {
    return (await import("./permission-details/lark.generated" as string))["firewallPermissionMetadata"];
  },
  ["line"]: async () => {
    return (await import("./permission-details/line.generated" as string))["firewallPermissionMetadata"];
  },
  ["linear"]: async () => {
    return (await import("./permission-details/linear.generated" as string))["firewallPermissionMetadata"];
  },
  ["loops"]: async () => {
    return (await import("./permission-details/loops.generated" as string))["firewallPermissionMetadata"];
  },
  ["luma"]: async () => {
    return (await import("./permission-details/luma.generated" as string))["firewallPermissionMetadata"];
  },
  ["luma-ai"]: async () => {
    return (await import("./permission-details/luma-ai.generated" as string))["firewallPermissionMetadata"];
  },
  ["mailchimp"]: async () => {
    return (await import("./permission-details/mailchimp.generated" as string))["firewallPermissionMetadata"];
  },
  ["mailsac"]: async () => {
    return (await import("./permission-details/mailsac.generated" as string))["firewallPermissionMetadata"];
  },
  ["make"]: async () => {
    return (await import("./permission-details/make.generated" as string))["firewallPermissionMetadata"];
  },
  ["manus"]: async () => {
    return (await import("./permission-details/manus.generated" as string))["firewallPermissionMetadata"];
  },
  ["mapbox"]: async () => {
    return (await import("./permission-details/mapbox.generated" as string))["firewallPermissionMetadata"];
  },
  ["maskdb"]: async () => {
    return (await import("./permission-details/maskdb.generated" as string))["firewallPermissionMetadata"];
  },
  ["massive"]: async () => {
    return (await import("./permission-details/massive.generated" as string))["firewallPermissionMetadata"];
  },
  ["mathpix"]: async () => {
    return (await import("./permission-details/mathpix.generated" as string))["firewallPermissionMetadata"];
  },
  ["mem0"]: async () => {
    return (await import("./permission-details/mem0.generated" as string))["firewallPermissionMetadata"];
  },
  ["mercury"]: async () => {
    return (await import("./permission-details/mercury.generated" as string))["firewallPermissionMetadata"];
  },
  ["meshy"]: async () => {
    return (await import("./permission-details/meshy.generated" as string))["firewallPermissionMetadata"];
  },
  ["meta-ads"]: async () => {
    return (await import("./permission-details/meta-ads.generated" as string))["firewallPermissionMetadata"];
  },
  ["metabase"]: async () => {
    return (await import("./permission-details/metabase.generated" as string))["firewallPermissionMetadata"];
  },
  ["microsoft-365"]: async () => {
    return (await import("./permission-details/microsoft-365.generated" as string))["firewallPermissionMetadata"];
  },
  ["minimax"]: async () => {
    return (await import("./permission-details/minimax.generated" as string))["firewallPermissionMetadata"];
  },
  ["miro"]: async () => {
    return (await import("./permission-details/miro.generated" as string))["firewallPermissionMetadata"];
  },
  ["mixpanel"]: async () => {
    return (await import("./permission-details/mixpanel.generated" as string))["firewallPermissionMetadata"];
  },
  ["modal"]: async () => {
    return (await import("./permission-details/modal.generated" as string))["firewallPermissionMetadata"];
  },
  ["monday"]: async () => {
    return (await import("./permission-details/monday.generated" as string))["firewallPermissionMetadata"];
  },
  ["moss"]: async () => {
    return (await import("./permission-details/moss.generated" as string))["firewallPermissionMetadata"];
  },
  ["msg9"]: async () => {
    return (await import("./permission-details/msg9.generated" as string))["firewallPermissionMetadata"];
  },
  ["n8n"]: async () => {
    return (await import("./permission-details/n8n.generated" as string))["firewallPermissionMetadata"];
  },
  ["neon"]: async () => {
    return (await import("./permission-details/neon.generated" as string))["firewallPermissionMetadata"];
  },
  ["netdata"]: async () => {
    return (await import("./permission-details/netdata.generated" as string))["firewallPermissionMetadata"];
  },
  ["netsuite"]: async () => {
    return (await import("./permission-details/netsuite.generated" as string))["firewallPermissionMetadata"];
  },
  ["nintendo-store"]: async () => {
    return (await import("./permission-details/nintendo-store.generated" as string))["firewallPermissionMetadata"];
  },
  ["nintendo-switch-parental-controls"]: async () => {
    return (await import("./permission-details/nintendo-switch-parental-controls.generated" as string))["firewallPermissionMetadata"];
  },
  ["notion"]: async () => {
    return (await import("./permission-details/notion.generated" as string))["firewallPermissionMetadata"];
  },
  ["novita"]: async () => {
    return (await import("./permission-details/novita.generated" as string))["firewallPermissionMetadata"];
  },
  ["nyne"]: async () => {
    return (await import("./permission-details/nyne.generated" as string))["firewallPermissionMetadata"];
  },
  ["onyx"]: async () => {
    return (await import("./permission-details/onyx.generated" as string))["firewallPermissionMetadata"];
  },
  ["openai"]: async () => {
    return (await import("./permission-details/openai.generated" as string))["firewallPermissionMetadata"];
  },
  ["openrouter"]: async () => {
    return (await import("./permission-details/openrouter.generated" as string))["firewallPermissionMetadata"];
  },
  ["openweather"]: async () => {
    return (await import("./permission-details/openweather.generated" as string))["firewallPermissionMetadata"];
  },
  ["outlook-calendar"]: async () => {
    return (await import("./permission-details/outlook-calendar.generated" as string))["firewallPermissionMetadata"];
  },
  ["outlook-mail"]: async () => {
    return (await import("./permission-details/outlook-mail.generated" as string))["firewallPermissionMetadata"];
  },
  ["pandadoc"]: async () => {
    return (await import("./permission-details/pandadoc.generated" as string))["firewallPermissionMetadata"];
  },
  ["parallel"]: async () => {
    return (await import("./permission-details/parallel.generated" as string))["firewallPermissionMetadata"];
  },
  ["paypal"]: async () => {
    return (await import("./permission-details/paypal.generated" as string))["firewallPermissionMetadata"];
  },
  ["pdf4me"]: async () => {
    return (await import("./permission-details/pdf4me.generated" as string))["firewallPermissionMetadata"];
  },
  ["pdfco"]: async () => {
    return (await import("./permission-details/pdfco.generated" as string))["firewallPermissionMetadata"];
  },
  ["pdforge"]: async () => {
    return (await import("./permission-details/pdforge.generated" as string))["firewallPermissionMetadata"];
  },
  ["people-data-labs"]: async () => {
    return (await import("./permission-details/people-data-labs.generated" as string))["firewallPermissionMetadata"];
  },
  ["perplexity"]: async () => {
    return (await import("./permission-details/perplexity.generated" as string))["firewallPermissionMetadata"];
  },
  ["pexels"]: async () => {
    return (await import("./permission-details/pexels.generated" as string))["firewallPermissionMetadata"];
  },
  ["pika"]: async () => {
    return (await import("./permission-details/pika.generated" as string))["firewallPermissionMetadata"];
  },
  ["pinecone"]: async () => {
    return (await import("./permission-details/pinecone.generated" as string))["firewallPermissionMetadata"];
  },
  ["pipedream"]: async () => {
    return (await import("./permission-details/pipedream.generated" as string))["firewallPermissionMetadata"];
  },
  ["pipedrive"]: async () => {
    return (await import("./permission-details/pipedrive.generated" as string))["firewallPermissionMetadata"];
  },
  ["plain"]: async () => {
    return (await import("./permission-details/plain.generated" as string))["firewallPermissionMetadata"];
  },
  ["plausible"]: async () => {
    return (await import("./permission-details/plausible.generated" as string))["firewallPermissionMetadata"];
  },
  ["playstation"]: async () => {
    return (await import("./permission-details/playstation.generated" as string))["firewallPermissionMetadata"];
  },
  ["podchaser"]: async () => {
    return (await import("./permission-details/podchaser.generated" as string))["firewallPermissionMetadata"];
  },
  ["porkbun"]: async () => {
    return (await import("./permission-details/porkbun.generated" as string))["firewallPermissionMetadata"];
  },
  ["posthog"]: async () => {
    return (await import("./permission-details/posthog.generated" as string))["firewallPermissionMetadata"];
  },
  ["printful"]: async () => {
    return (await import("./permission-details/printful.generated" as string))["firewallPermissionMetadata"];
  },
  ["prisma-postgres"]: async () => {
    return (await import("./permission-details/prisma-postgres.generated" as string))["firewallPermissionMetadata"];
  },
  ["productlane"]: async () => {
    return (await import("./permission-details/productlane.generated" as string))["firewallPermissionMetadata"];
  },
  ["profound"]: async () => {
    return (await import("./permission-details/profound.generated" as string))["firewallPermissionMetadata"];
  },
  ["pushinator"]: async () => {
    return (await import("./permission-details/pushinator.generated" as string))["firewallPermissionMetadata"];
  },
  ["qdrant"]: async () => {
    return (await import("./permission-details/qdrant.generated" as string))["firewallPermissionMetadata"];
  },
  ["qiita"]: async () => {
    return (await import("./permission-details/qiita.generated" as string))["firewallPermissionMetadata"];
  },
  ["quickbooks"]: async () => {
    return (await import("./permission-details/quickbooks.generated" as string))["firewallPermissionMetadata"];
  },
  ["railway"]: async () => {
    return (await import("./permission-details/railway.generated" as string))["firewallPermissionMetadata"];
  },
  ["railway-project"]: async () => {
    return (await import("./permission-details/railway-project.generated" as string))["firewallPermissionMetadata"];
  },
  ["ramp"]: async () => {
    return (await import("./permission-details/ramp.generated" as string))["firewallPermissionMetadata"];
  },
  ["reap"]: async () => {
    return (await import("./permission-details/reap.generated" as string))["firewallPermissionMetadata"];
  },
  ["recraft"]: async () => {
    return (await import("./permission-details/recraft.generated" as string))["firewallPermissionMetadata"];
  },
  ["reddit"]: async () => {
    return (await import("./permission-details/reddit.generated" as string))["firewallPermissionMetadata"];
  },
  ["reducto"]: async () => {
    return (await import("./permission-details/reducto.generated" as string))["firewallPermissionMetadata"];
  },
  ["render"]: async () => {
    return (await import("./permission-details/render.generated" as string))["firewallPermissionMetadata"];
  },
  ["rentcast"]: async () => {
    return (await import("./permission-details/rentcast.generated" as string))["firewallPermissionMetadata"];
  },
  ["replicate"]: async () => {
    return (await import("./permission-details/replicate.generated" as string))["firewallPermissionMetadata"];
  },
  ["reportei"]: async () => {
    return (await import("./permission-details/reportei.generated" as string))["firewallPermissionMetadata"];
  },
  ["resend"]: async () => {
    return (await import("./permission-details/resend.generated" as string))["firewallPermissionMetadata"];
  },
  ["revenuecat"]: async () => {
    return (await import("./permission-details/revenuecat.generated" as string))["firewallPermissionMetadata"];
  },
  ["runway"]: async () => {
    return (await import("./permission-details/runway.generated" as string))["firewallPermissionMetadata"];
  },
  ["salesforce"]: async () => {
    return (await import("./permission-details/salesforce.generated" as string))["firewallPermissionMetadata"];
  },
  ["scrapeninja"]: async () => {
    return (await import("./permission-details/scrapeninja.generated" as string))["firewallPermissionMetadata"];
  },
  ["segment"]: async () => {
    return (await import("./permission-details/segment.generated" as string))["firewallPermissionMetadata"];
  },
  ["semrush"]: async () => {
    return (await import("./permission-details/semrush.generated" as string))["firewallPermissionMetadata"];
  },
  ["sendgrid"]: async () => {
    return (await import("./permission-details/sendgrid.generated" as string))["firewallPermissionMetadata"];
  },
  ["sentry"]: async () => {
    return (await import("./permission-details/sentry.generated" as string))["firewallPermissionMetadata"];
  },
  ["serpapi"]: async () => {
    return (await import("./permission-details/serpapi.generated" as string))["firewallPermissionMetadata"];
  },
  ["servicenow"]: async () => {
    return (await import("./permission-details/servicenow.generated" as string))["firewallPermissionMetadata"];
  },
  ["shopify"]: async () => {
    return (await import("./permission-details/shopify.generated" as string))["firewallPermissionMetadata"];
  },
  ["shortio"]: async () => {
    return (await import("./permission-details/shortio.generated" as string))["firewallPermissionMetadata"];
  },
  ["similarweb"]: async () => {
    return (await import("./permission-details/similarweb.generated" as string))["firewallPermissionMetadata"];
  },
  ["slack"]: async () => {
    return (await import("./permission-details/slack.generated" as string))["firewallPermissionMetadata"];
  },
  ["slack-webhook"]: async () => {
    return (await import("./permission-details/slack-webhook.generated" as string))["firewallPermissionMetadata"];
  },
  ["slock"]: async () => {
    return (await import("./permission-details/slock.generated" as string))["firewallPermissionMetadata"];
  },
  ["snowflake"]: async () => {
    return (await import("./permission-details/snowflake.generated" as string))["firewallPermissionMetadata"];
  },
  ["sociavault"]: async () => {
    return (await import("./permission-details/sociavault.generated" as string))["firewallPermissionMetadata"];
  },
  ["sponge"]: async () => {
    return (await import("./permission-details/sponge.generated" as string))["firewallPermissionMetadata"];
  },
  ["spotify"]: async () => {
    return (await import("./permission-details/spotify.generated" as string))["firewallPermissionMetadata"];
  },
  ["sproutgigs"]: async () => {
    return (await import("./permission-details/sproutgigs.generated" as string))["firewallPermissionMetadata"];
  },
  ["square"]: async () => {
    return (await import("./permission-details/square.generated" as string))["firewallPermissionMetadata"];
  },
  ["stability-ai"]: async () => {
    return (await import("./permission-details/stability-ai.generated" as string))["firewallPermissionMetadata"];
  },
  ["steam"]: async () => {
    return (await import("./permission-details/steam.generated" as string))["firewallPermissionMetadata"];
  },
  ["strapi"]: async () => {
    return (await import("./permission-details/strapi.generated" as string))["firewallPermissionMetadata"];
  },
  ["strava"]: async () => {
    return (await import("./permission-details/strava.generated" as string))["firewallPermissionMetadata"];
  },
  ["streak"]: async () => {
    return (await import("./permission-details/streak.generated" as string))["firewallPermissionMetadata"];
  },
  ["stripe"]: async () => {
    return (await import("./permission-details/stripe.generated" as string))["firewallPermissionMetadata"];
  },
  ["supabase"]: async () => {
    return (await import("./permission-details/supabase.generated" as string))["firewallPermissionMetadata"];
  },
  ["supadata"]: async () => {
    return (await import("./permission-details/supadata.generated" as string))["firewallPermissionMetadata"];
  },
  ["supermemory"]: async () => {
    return (await import("./permission-details/supermemory.generated" as string))["firewallPermissionMetadata"];
  },
  ["tavily"]: async () => {
    return (await import("./permission-details/tavily.generated" as string))["firewallPermissionMetadata"];
  },
  ["test-oauth"]: async () => {
    return (await import("./permission-details/test-oauth.generated" as string))["firewallPermissionMetadata"];
  },
  ["testrail"]: async () => {
    return (await import("./permission-details/testrail.generated" as string))["firewallPermissionMetadata"];
  },
  ["ticketmaster"]: async () => {
    return (await import("./permission-details/ticketmaster.generated" as string))["firewallPermissionMetadata"];
  },
  ["tiktok-ads"]: async () => {
    return (await import("./permission-details/tiktok-ads.generated" as string))["firewallPermissionMetadata"];
  },
  ["tldv"]: async () => {
    return (await import("./permission-details/tldv.generated" as string))["firewallPermissionMetadata"];
  },
  ["todoist"]: async () => {
    return (await import("./permission-details/todoist.generated" as string))["firewallPermissionMetadata"];
  },
  ["together"]: async () => {
    return (await import("./permission-details/together.generated" as string))["firewallPermissionMetadata"];
  },
  ["tripo"]: async () => {
    return (await import("./permission-details/tripo.generated" as string))["firewallPermissionMetadata"];
  },
  ["twenty"]: async () => {
    return (await import("./permission-details/twenty.generated" as string))["firewallPermissionMetadata"];
  },
  ["twilio"]: async () => {
    return (await import("./permission-details/twilio.generated" as string))["firewallPermissionMetadata"];
  },
  ["typeform"]: async () => {
    return (await import("./permission-details/typeform.generated" as string))["firewallPermissionMetadata"];
  },
  ["v0"]: async () => {
    return (await import("./permission-details/v0.generated" as string))["firewallPermissionMetadata"];
  },
  ["vercel"]: async () => {
    return (await import("./permission-details/vercel.generated" as string))["firewallPermissionMetadata"];
  },
  ["wandb"]: async () => {
    return (await import("./permission-details/wandb.generated" as string))["firewallPermissionMetadata"];
  },
  ["webflow"]: async () => {
    return (await import("./permission-details/webflow.generated" as string))["firewallPermissionMetadata"];
  },
  ["weread"]: async () => {
    return (await import("./permission-details/weread.generated" as string))["firewallPermissionMetadata"];
  },
  ["whale-alert"]: async () => {
    return (await import("./permission-details/whale-alert.generated" as string))["firewallPermissionMetadata"];
  },
  ["wix"]: async () => {
    return (await import("./permission-details/wix.generated" as string))["firewallPermissionMetadata"];
  },
  ["workday"]: async () => {
    return (await import("./permission-details/workday.generated" as string))["firewallPermissionMetadata"];
  },
  ["workos"]: async () => {
    return (await import("./permission-details/workos.generated" as string))["firewallPermissionMetadata"];
  },
  ["wrike"]: async () => {
    return (await import("./permission-details/wrike.generated" as string))["firewallPermissionMetadata"];
  },
  ["x"]: async () => {
    return (await import("./permission-details/x.generated" as string))["firewallPermissionMetadata"];
  },
  ["xero"]: async () => {
    return (await import("./permission-details/xero.generated" as string))["firewallPermissionMetadata"];
  },
  ["youtube"]: async () => {
    return (await import("./permission-details/youtube.generated" as string))["firewallPermissionMetadata"];
  },
  ["zapier"]: async () => {
    return (await import("./permission-details/zapier.generated" as string))["firewallPermissionMetadata"];
  },
  ["zapsign"]: async () => {
    return (await import("./permission-details/zapsign.generated" as string))["firewallPermissionMetadata"];
  },
  ["zendesk"]: async () => {
    return (await import("./permission-details/zendesk.generated" as string))["firewallPermissionMetadata"];
  },
  ["zep"]: async () => {
    return (await import("./permission-details/zep.generated" as string))["firewallPermissionMetadata"];
  },
  ["zeptomail"]: async () => {
    return (await import("./permission-details/zeptomail.generated" as string))["firewallPermissionMetadata"];
  },
  ["zoom"]: async () => {
    return (await import("./permission-details/zoom.generated" as string))["firewallPermissionMetadata"];
  },
} satisfies Readonly<
  Record<string, () => Promise<FirewallPermissionDetailMetadata>>
>);

export async function loadGeneratedFirewallPermissionMetadata(
  type: string,
): Promise<FirewallPermissionDetailMetadata | null> {
  const load = FIREWALL_PERMISSION_METADATA_LOADERS[type];
  if (!load) {
    return null;
  }
  return await load();
}
